const STRIPE_PRICING_TABLE_SCRIPT_SRC = 'https://js.stripe.com/v3/pricing-table.js';

export const ensureStripePricingTableScript = (): void => {
    if (typeof document === 'undefined') {
        return;
    }

    const existingScript = document.querySelector(`script[src="${STRIPE_PRICING_TABLE_SCRIPT_SRC}"]`);
    if (existingScript) {
        return;
    }

    const stripePricingTableScript = document.createElement('script');
    stripePricingTableScript.setAttribute('src', STRIPE_PRICING_TABLE_SCRIPT_SRC);
    stripePricingTableScript.async = true;
    document.head.appendChild(stripePricingTableScript);
};

export default ensureStripePricingTableScript;
